
import type React from "react"

const Error: React.FC = () => {
  return (
    <div className="min-h-screen  flex items-center justify-center bg-[#3FBBA3] relative  w-full">
      {/* Background pattern */}
      <div className="absolute inset-0 w-full overflow-hidden ">
        <div className="absolute w-full h-full bg-[#3FBBA3] opacity-80"></div>
        <div className="absolute w-full h-full">
          {/* Diagonal lines */}
          <div className="absolute bottom-0 left-0 w-full h-[50%] bg-[#3FBBA3] opacity-30 transform rotate-6 translate-y-1/2"></div>
          <div className="absolute top-0 right-0 w-full h-[50%] bg-[#3FBBA3] opacity-30 transform -rotate-6 -translate-y-1/2"></div>
        </div>
      </div>

      {/* Error container */}
      <div className="relative z-10 w-full max-w-md mx-auto p-8 rounded-lg shadow-2xl bg-white text-gray-900 dark:bg-gray-900 dark:text-white transition-colors duration-300">
        <h1 className="text-8xl font-bold text-center mb-4">401</h1>
        <p className="text-center text-lg font-medium mb-2">Oops, the page you are trying to access does not exist!</p>
        <p className="text-center text-sm opacity-80 mb-6">
          The requested page is not available. It might have been relocated, deleted, or never existed.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button className="px-4 py-2 rounded-md bg-[#3FBBA3] text-white font-medium hover:bg-[#36a892] transition-colors">
            Home Page
          </button>
          <button className="px-4 py-2 rounded-md bg-orange-500 text-white font-medium hover:bg-orange-600 transition-colors">
            Visit Help Center
          </button>
        </div>
      </div>
    </div>
  )
}

export default Error

